module.exports = __webpack_public_path__ + "media/images/stimulans-c7982780db622f9728404d9ecba35692.png";